import Module from "./Module.vue";
import DashboardPengaturanUmum from "./views/DashboardPengaturanUmum.vue";
import PaketEPayment from "./views/PaketEPayment.vue";
import ReminderMasaAktif from "./views/ReminderMasaAktif";
import PenyesuaianPaketEpayment from "@/modules/pengaturan-umum/views/PenyesuaianPaketEpayment";
import PengaturanLaporan from "./views/PengaturanLaporan.vue";

import SOConfirmSetEpayment from "./components/SOConfirmSetEpayment.vue";

const requireAuth = { requireAuth: true };

const moduleRoute = {
    path: "/pengaturan-umum",
    component: Module,
    children: [
        {
            path: "",
            name: "pengaturanUmum.dashboard",
            component: DashboardPengaturanUmum,
            meta: {
                ...requireAuth,
                accessKey: 'generalSettings',
            },
        },
        {
            path: "masa-aktif-paket-epaymnet",
            component: Module,
            children: [
                {
                    path: "",
                    name: "pengaturanUmum.paket_epayment",
                    component: PaketEPayment,
                    meta: {
                        ...requireAuth,
                        accessKey: 'generalSettings.epaymentActivePeriod',
                    },
                },
                {
                    path: "penyesuaian",
                    name: "pengaturanUmum.penyesuaian",
                    component: PenyesuaianPaketEpayment,
                    meta: {
                        ...requireAuth,
                        accessKey: 'epaymentActivePeriod.update',
                    },
                },
                {
                    path: "confirm-setting",
                    name: "pengaturanUmum.confirm_setting",
                    components: {
                        default: PaketEPayment,
                        dialog: SOConfirmSetEpayment,
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'epaymentActivePeriod.update',
                    },
                },
            ],
        },
        {
            path: "reminder-masa-aktif",
            name: "pengaturanUmum.reminder-masa-aktif",
            component: ReminderMasaAktif,
            meta: {
                ...requireAuth,
                accessKey: 'generalSettings.activePeriodReminder',
            },
        },
        {
            path: "ambil-tanpa-lunasi",
            name: "pengaturanUmum.ambil-tanpa-lunasi",
            component: () => import("./views/AmbilTanpaLunasi.vue"),
            meta: {
                ...requireAuth,
                accessKey: 'generalSettings.takeWithoutPay',
            },
        },
        {
            path: "cashback-period",
            name: "pengaturanUmum.masa-aktif-cashback",
            component: () => import("./views/MasaAktifCashback.vue"),
            meta: {
                ...requireAuth,
                // accessKey: 'generalSettings.takeWithoutPay',
            },
        },
		{
            path: "poin-active-period",
            name: "pengaturanUmum.poin-active-period",
            component: () => import("./views/PointActivePeriod.vue"),
            meta: {
                ...requireAuth,
                // accessKey: 'generalSettings.takeWithoutPay',
            },
        },
        {
            path: "wa-nota",
            name: "pengaturanUmum.wa-nota",
            component: () => import("./views/PengirimanWaNota.vue"),
            meta: {
                ...requireAuth,
                // accessKey: 'generalSettings.takeWithoutPay',
            },
        },
        {
            path: "pelunasan-invoice",
            name: "pengaturanUmum.pelunasan-invoice",
            component: () => import("./views/PelunasanInvoice.vue"),
            meta: {
                ...requireAuth,
                accessKey: 'generalSettings.invoicePayoff',
            },
        },
        {
            path: "pengaturan-laporan",
            component: Module,

            children: [
                {
                    path: "",
                    name: "pengaturanUmum.pengaturan-laporan",
                    component: PengaturanLaporan,
                    meta: requireAuth,
                },
                {
                    path: "pilih-item/:pengaturan",
                    name: "pengaturanUmum.pengaturan-laporan.pilih-item",
                    components: {
                        default: PengaturanLaporan,
                        dialog: () => {
                            return import("./views/modal/PilihSumberBiaya.vue");
                        },
                    },
                    meta: requireAuth,
                },
            ],
        },
    ],
};

export default (router) => {
    router.addRoutes([moduleRoute]);
};
